/* eslint-disable no-unused-vars */
import AsyncStorage from '@react-native-async-storage/async-storage';
import { uploadS3 } from '@global/helpers';
import { storageName } from '@global/background';

const processFinishUploadQueue = async () => {
  const storages = await AsyncStorage.getItem(storageName.uploadImage);
  if (storages) {
    const queues = JSON.parse(storages);
    if (queues?.length) {
      const remaining = queues.filter((q) => q.process != 2);
      await AsyncStorage.setItem(
        storageName.uploadImage,
        JSON.stringify(remaining),
      );
    }
  }
};

// processing to upload images
const processUploadImageQueue = async () => {
  // get pending or failed queue
  const storages = await AsyncStorage.getItem(storageName.uploadImage);
  if (storages) {
    const queues = JSON.parse(storages);
    if (queues?.length) {
      const results = [];
      for (let i = 0; i < queues.length; i++) {
        const item = queues[i];
        console.log(
          `Processing: Upload Image Activity ${item.additional.activity._id} Task ${item.additional.task._id}`,
        );
        results.push({
          ...item,
          process: 1,
        });

        try {
          // uploading image
          const res = await uploadS3({
            file: item.image,
            isImage: true,
          });

          if (res) {
            console.log('habis upload ke s3', res);
            results[i].url = res;
            results[i].process = 2;
            console.log(
              `Processed: Upload Image Activity ${item.additional.activity._id} Task ${item.additional.task._id}`,
            );
          } else {
            results[i].process = 0;
            console.log(
              `Failed: Upload Image Activity ${item.additional.activity._id} Task ${item.additional.task._id}`,
            );
          }
        } catch (error) {
          // rollback when process is failed
          results[i].process = 0;
          console.log(
            `Failed: Upload Image Activity ${item.additional.activity._id} Task ${item.additional.task._id}`,
          );
        }
      }
      // updating queue list
      await AsyncStorage.setItem(
        storageName.uploadImage,
        JSON.stringify(results),
      );
      if (results.findIndex((r) => r.process == 2) > -1) {
        // run update db when some queue done
        processFinishUploadQueue();
      }
    }
  }
};

export { processUploadImageQueue };
